import { getTargetPriority, TargetPriority } from '@/utils/sprintTarget';

interface SprintTargetProps {
  target?: string;
  className?: string;
}

const TargetIcon = ({ priority }: { priority: TargetPriority }) => {
  if (priority === 'high') {
    return (
      <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 20 20">
        <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
      </svg>
    );
  }
  
  return (
    <svg className="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  );
};

export default function SprintTarget({ target, className = "" }: SprintTargetProps) {
  const priority = getTargetPriority(target);
  
  if (priority === 'none') return null;
  
  const priorityStyles = priority === 'high' 
    ? 'border-red-200 bg-red-50 text-red-800 dark:border-red-800 dark:bg-red-900/20 dark:text-red-300'
    : 'border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-800 dark:bg-blue-900/20 dark:text-blue-300';
  
  return (
    <div 
      className={`flex items-start gap-2 p-2 rounded-md border text-sm ${priorityStyles} ${className}`}
      title={target}
    >
      <TargetIcon priority={priority} />
      <span className="flex-1 leading-tight whitespace-pre-wrap">{target}</span>
    </div>
  );
}